import { render, staticRenderFns } from "./TemplateDialog.vue?vue&type=template&id=205c0b88&scoped=true&"
import script from "./TemplateDialog.vue?vue&type=script&lang=js&"
export * from "./TemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDialog.vue?vue&type=style&index=0&id=205c0b88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205c0b88",
  null
  
)

export default component.exports